import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/UpdateRepository'


class CreateBloc {

    detailChannel = new Subject();
    checkChannel = new Subject();
    createChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.checkChannel.next({status: apiResponse.INITIAL})
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchUpdate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchUpdate(query).then((result) => {
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.createChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchCheck = async (query) => {
        this.checkChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCheck(query).then((result) => {
            this.checkChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.checkChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

}

export default CreateBloc